import React from 'react'
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userPayload } from "Pages/Admin/Users/@signals"
import { BACKEND_APIS } from "@constants"

export default function UserDateFormat() {

	const { dateFormat, setDateFormatInfo } = useAdminUsersInfo(userPayload.peek()?.userConfig?.dateFormat, "dateFormat", "userConfig")

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		value={dateFormat}
		onChange={e => setDateFormatInfo(e.target.value)}
		label="Website Date Format"
		placeholder="Any format"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/date/options/date_format`}
	/>
}